import { useEffect, useState } from "react";
import { NLAExpandable } from "../NLAExpandable/NLAExpandable";
import "./NLAContainer.scss";
import { buildFlatTreeFromArray } from "../../../../../../utils/utils";

export const NLAContainer = ({
  partNLAs,
  quickSN = false,
  sortCriteria = "",
  isPo = false,
  openedNodeId = null, // Nueva prop
  editMode = false, // Nueva prop
  onCloseDetail = () => {},
  reloadNLAList
}) => {
  const [flatTree, setFlatTree] = useState([]);
  const [openedNodes, setOpenedNodes] = useState({});

  useEffect(() => {
    const tree = buildFlatTreeFromArray(partNLAs, sortCriteria);
    setFlatTree(tree);

    // // DEBUG: Verificar sorting
    // console.log("Árbol ordenado con criterio:", sortCriteria);
    // tree.forEach((node, index) => {
    //   const indent = "  ".repeat(node.level);
    //   console.log(
    //     `${index}. ${indent}Nivel ${node.level}: ${node.partNumber} | SN: ${
    //       node.serialNumber || "NULL"
    //     } | Pos: ${node.positions}`
    //   );
    // });
  }, [partNLAs, sortCriteria]);

  const showNode = (node) => {
    return node.parentIds.every((parentId) => openedNodes[parentId] === true);
  };

  const isNodeOpen = (node) => {
    return openedNodes[node.nodeId] === true;
  };

  const toggleNode = (node) => {
    setOpenedNodes((prev) => ({
      ...prev,
      [node.nodeId]: !prev[node.nodeId],
    }));
  };

  return (
    <div className="receiving-nla-cont">
      {flatTree.map((node, idx) => {
        // Solo renderizar si el nodo debe mostrarse
        if (!showNode(node)) return null;

        return (
          <NLAExpandable
            key={node.nodeId}
            node={node}
            tree={flatTree}
            idx={idx}
            isNodeOpen={isNodeOpen}
            showNode={showNode}
            toggleNode={toggleNode}
            quickSN={quickSN}
            isPO={isPo}
            isOpenedProgrammatically={openedNodeId === node.nodeId}
            isEditMode={editMode && openedNodeId === node.nodeId}
            onCloseDetail={onCloseDetail}
            reloadNLAList={reloadNLAList}
          />
        );
      })}
    </div>
  );
};
